/**
 * Created by qinlili.
 */
<template>
  <div style="height: calc(100% - 96px);">
    <div class="container">
      <page-header :title="title" v-if="!isDialog" :customFun="back">
      </page-header>
      <div class="content-wrap" :class="{'content-wrap--padding': !isDialog}">
        <step :active="active" :stepArr="stepArr"></step>
        <div class="import-content">
          <!--第一步-->
          <template v-if="active === 1">
            <div v-if="$slots['upload-tip'] && isShowUploadTips" class="upload-tip">
              <tip-box>
                <slot name="upload-tip"></slot>
                <template slot="close-icon">
                  <i class="close-icon" @click="isShowUploadTips =  false"></i>
                </template>
              </tip-box>
            </div>
            <fe-upload
              ref="upload"
              :action="`${importApis.upload.url}?importType=${this.importType}`"
              @uploadSuccess="uploadSuccess"
              @changeFiles="changeFiles"
              :downloadFn="downloadFn"
              :downloadValidate="downloadValidate"
              :downloadTemplate="`${importApis.downloadTemplate.url}?importType=${this.importType}`">
            </fe-upload>
          </template>
          <!--第二步-->
          <template v-if="active === 2">
            <div class="tip">
              <tip-box>
                <p>
                  <span v-html="variableReplace(pageText.importErrTip, {allNum: failCount+successCount, errNum: '<span class=highlight>' + failCount + '</span>'})"></span>
                  <el-button v-if="failCount" @click="downloadAll" size="mini" type="primary" plain>{{pageText.downFileBtn}}</el-button>
                </p>
              </tip-box>
            </div>
            <slot name="table" :tableData="tableData"></slot>
            <div class="see-more" v-show="tableData.length < totalCount" @click="lookMore">
              {{clickLoadMore}}>
            </div>
          </template>
          <!--第三步-->
          <template v-if="active === 3">
            <div class="import-result-tips">
              <template v-if="!failCount">
                <div class="part-success-tip">
                  <i class="el-icon-circle-check font-color-success"></i>
                  <span v-if="isDialog" v-html="variableReplace(pageText.importLaterTip, {sec: '<span class=highlight>3</span>'})"></span>
                  <span v-else class="success-text-tip text-tip">{{pageText.operationSuccess}}</span>
                </div>
              </template>
              <div v-else class="part-fail-tip">
                <i class="icon-warning"></i>
                <span class="fail-text-tip text-tip" v-html="variableReplace(pageText.importNumTip, {successCount: successCount, failCount: '<span class=highlight>' + failCount + '</span>'})"></span>
              </div>
            </div>
          </template>
          <!--按钮区-->
          <div class="buttons">
            <scroll-follow ref="scrollFollow" :disabled="isDialog" :width="isDialog ? 'auto' : '1150'">
              <div class="buttons-wrap">
                <el-button v-if="leftButtonText" type="default" size="medium" @click="handleLeftButton" :plain="active === 3">{{leftButtonText}}</el-button>
                <el-button v-if="rightButtonText" :disabled="this.active === 2 && !successCount"  type="primary" size="medium" @click="handleRightButton">{{rightButtonText}}</el-button>
              </div>
            </scroll-follow>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
  import getResponse, {isResponseOk} from '../../../utils/response'
  import importApis from './api.js'
  import download from '../../../utils/download'
  import PageHeader from '../../basis/header/index.vue'
  import FeUpload from '../../business/upload/upload.vue'
  import TipBox from '../../basis/tip-box/tip-box'
  import Step from '../../basis/step/step.vue'
  import ScrollFollow from '../../basis/scroll-follow'
  import { componentMessage } from '../utils'
  import i18n from './i18n'
  const pageText = window.fe.getPageText(i18n)

  export default {
    name: 'step-import',
    components: {
      PageHeader,
      FeUpload,
      TipBox,
      Step,
      ScrollFollow
    },
    props: {
      'title': String,
      'importType': String,
      'returnText': {
        type: String,
        default: pageText.backList
      },
      'returnPath': {
        type: String,
        default: '/'
      },
      // 是否弹层形式
      isDialog: {
        type: Boolean,
        default: false
      },
      // 是否需要确人导入
      needImportConfirm: {
        type: Boolean,
        default: true
      },
      // 是否在关闭时获取正确数据，只在弹层模式下用
      needGetSuccessData: {
        type: Boolean,
        default: true
      },
      // 下载前的校验
      downloadValidate: {
        type: Object,
        default: () => {
          return {
            url: '',
            method: '',
            param: {}
          }
        }
      },
      // 下载模板方法
      downloadFn: Function
    },
    data: function () {
      return {
        pageText,
        isShowUploadTips: true,
        stepArr: [pageText.importData, pageText.checkImport, pageText.finish],
        active: 1,
        key: '', // 任务的key
        successCount: 0, // 导入成功的条数
        failCount: 0, // 导入失败的条数
        importApis,
        // 列表展示
        tableData: [],
        totalCount: null,
        page: 0,
        closed: false,
        componentMessage
      }
    },
    computed: {
      // 右侧按钮文字
      rightButtonText () {
        switch (this.active) {
          case 1:
            return this.pageText.nextStep
          case 2:
            return this.pageText.upSuccessData
          case 3:
            return this.failCount
              ? this.pageText.downErrData
              : this.isDialog
                ? this.pageText.close
                : this.returnText
          default:
            return ''
        }
      },
      // 左侧按钮文字
      leftButtonText () {
        switch (this.active) {
          case 2:
            return this.pageText.beforeStep
          case 3:
            return this.failCount
              ? this.isDialog
                ? this.pageText.close
                : this.returnText
              : ''
          default:
            return ''
        }
      }
    },
    created () {
      let flag = this.componentMessage(['mall', 'purchaser', 'supplier'], 'step-import')
      if (flag) return
    },
    updated () {
      this.$refs['scrollFollow'] && this.$refs['scrollFollow'].update()
    },
    methods: {
      variableReplace: window.fe.variableReplace,
      // 右侧按钮操作
      handleRightButton () {
        const self = this
        if (self.active === 1) {
          // self.active++ // todo
          // 上传完成后，下一步
          if (self.key) {
            self.active++
            self.loadDataList(true)
          } else {
            self.$message.warning(self.pageText.importTips)
          }
        } else if (self.active === 2) {
          // self.active++ // todo
          // 导入有效数据
          this.loadValid()
        } else if (self.active === 3) {
          if (self.failCount) {
            // 下载问题数据
            const api = this.importApis.error
            download(api.type, api.url, {
              key: self.key,
              importType: this.importType
            })
          } else {
            // 返回列表或关闭
            this.isDialog ? this.close() : this.back()
          }
        }
      },
      // 左侧按钮操作
      handleLeftButton () {
        if (this.active === 2) {
          // 当前在预览界面,点击上一步, 需重置数据
          this.reset()

          this.active -= 1
        } else if (this.active === 3) {
          // 返回列表或关闭
          this.isDialog ? this.close() : this.back()
        }
      },
      // 返回列表页面
      back () {
        this.$routerPush(this.returnPath)
      },
      // 弹层形式时，关闭
      async close () {
        if (this.closed) return
        if (!this.needGetSuccessData) {
          this.$emit('confirm', {
            key: this.key
          })
          this.closed = true
          return
        }
        const api = this.importApis.getSuccessData
        const res = await getResponse(this.$http(api.type, api.url, {
          'importType': this.importType,
          'key': this.key,
          'successCount': this.successCount // 导入模板时返回的成功数量
        }), {
          loadingOptions: false
        })
        if (res.isOk) {
          this.$emit('confirm', {
            key: this.key,
            content: res.content
          })
          this.closed = true
        }
      },
      // 上传表格文件成功
      async uploadSuccess (res) {
        const self = this
        // 有后台返回content为空的情况
        if (!res.content) {
          this.reset()
        }
        if (isResponseOk(res)) {
          self.key = res.content.key
          self.successCount = res.content.success
          self.failCount = res.content.fail
          self.$message.success(self.pageText.upSuccess)
        } else {
          self.key = ''
        }
      },
      // 文件选取发生变化
      async changeFiles (files) {
        if (!files) {
          this.reset()
        }
      },
      // 获取列表数据
      async loadDataList (isFirst) {
        const api = this.importApis.list
        const param = {
          key: this.key,
          page: isFirst ? 1 : ++this.page,
          pageSize: isFirst ? 10 : 500
        }
        const res = await getResponse(this.$http(api.type, api.url, param), {
          loadingOptions: true
        })
        if (res.isOk) {
          if (isFirst || this.page === 1) {
            this.tableData = res.content
          } else {
            this.tableData = this.tableData.concat(res.content)
          }
          this.totalCount = res.count
        }
      },
      // 列表加载更多
      lookMore () {
        this.loadDataList(false)
      },
      // 下载所有数据（有错误标识）
      async downloadAll () {
        const api = this.importApis.downloadAllData
        download(api.type, api.url, {
          key: this.key,
          importType: this.importType
        })
      },
      // 导入有效数据
      async loadValid () {
        const self = this
        if (self.needImportConfirm) {
          const api = self.importApis.confirm
          const param = {
            key: self.key,
            importType: this.importType
          }
          const data = await getResponse(self.$http(api.type, api.url, param), {
            loadingOptions: true
          })
          if (data.isOk && data.content) {
            self.successCount = data.content.success
            self.failCount = data.content.fail
            self.active++
          }
        } else {
          self.active++
        }

        // 进入第三步 + 弹层形式 + 没有错误数据时： 3s后自动关闭
        if (self.active === 3 && !self.failCount && self.isDialog) {
          setTimeout(function () {
            self.close()
          }, 3000)
        }
      },
      // 重置
      reset () {
        this.key = ''
        this.successCount = 0
        this.failCount = 0
        this.tableData = []
        this.totalCount = null
        this.page = 0

        this.$refs['upload'] && this.$refs['upload'].reset()
      }
    }
  }
</script>
<style lang="scss" scoped>
  .content-wrap{
    position: relative;
  }
  .content-wrap--padding{
    padding: 30px 25px 100px;
    border: 1px solid #D6DFFF;
    border-radius: 8px;
    background: #fff;
    margin-bottom: 8px;
  }
  .import-content{
    padding-top: 30px;
  }
  .upload-tip{
    margin-top: -10px;
    margin-bottom: -40px;
    .close-icon{
      display: inline-block;
      background: url($img-url + "156221174329914369.svg") no-repeat;
      width: 100%;
      height: 100%;
    }
  }
  .tip {
    margin: 10px auto;
  }
  .see-more{
    margin-top: 10px;
    font-size: 14px;
    color: #3072F3;
    cursor: pointer;
  }
  .red{
    color: #F23D3D;
  }
  .buttons{
    margin-top: 75px;
  }
  .buttons-wrap{
    text-align: center;
    line-height: 65px;
  }
  .guide{
    width: 230px;
    a{
      display: inline-block;
      width: 120px;
      height: 120px;
      margin-bottom: 8px;
    }
  }
  /*导入完成时的样式*/
  .import-result-tips{
    padding-top: 110px;
    text-align: center;
    font-size: 24px;
    .part-success-tip {
      i{
        font-size: 58px;
        vertical-align: middle;
      }
    }
    .part-fail-tip{
      padding-left: 5px;
      .icon-warning{
        display: inline-block;
        height: 53px;
        width: 53px;
        background: url($img-url + "1545644088269warning.png") no-repeat;
        -webkit-background-size: 53px;
        background-size: 53px;
        vertical-align: middle;
      }
    }
    .text-tip {
      margin-left: 15px;
      color: #2C2C2C;
      font-weight: 500;
    }
  }
</style>

